import { titleReverse, titleSeparator } from '@/config'
import store from '@/store'

/**
 * @description 设置标题
 * @param pageTitle
 * @returns {string}
 */
export default function getPageTitle (pageTitle) {
  const title = store.getters['settings/title']
//   let newTitles = []
//   if (pageTitle) newTitles.push(pageTitle)
//   if (title) newTitles.push(title)
//   if (titleReverse) newTitles = newTitles.reverse()
//   return newTitles.join(titleSeparator)
    return title
}
